import { FunctionComponent, ReactNode, MouseEventHandler } from 'react';
import { Box } from './components/Box';
import { Field } from '../Common/Field/Field';
import { FormLabel } from '../Common/FormLabel/FormLabel';
import classNames from 'classnames';

import styles from './main.scss';

export type BoxSelectOption = {
    label: ReactNode;
    value: string;
};

type BoxSelectProps = {
    label?: ReactNode;
    dataTn: string;
    value?: string;
    disabled?: boolean;
    onChange: MouseEventHandler<HTMLButtonElement>;
    options: BoxSelectOption[];
    size?: keyof typeof styles;
};

export const BoxSelect: FunctionComponent<BoxSelectProps> = props => {
    const {
        label = '',
        dataTn,
        value = '',
        disabled = false,
        onChange,
        options,
        size = 'medium',
    } = props;

    const boxSelectClassName = classNames(styles.boxSelect);

    return (
        <Field>
            <FormLabel>{label}</FormLabel>
            <div className={boxSelectClassName} data-tn={dataTn}>
                {options.map(val => {
                    return (
                        <Box
                            isSelected={value === val.value}
                            size={size}
                            label={val.label}
                            value={val.value}
                            dataTn={dataTn}
                            onClick={onChange}
                            isDisabled={disabled}
                            key={val.value}
                        />
                    );
                })}
            </div>
        </Field>
    );
};
